import React, { ReactNode, useState } from 'react'
import classNames from 'classnames'
import { Card, CardHeader, CardHeaderProps, Collapse, IconButton } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { ExpandMore } from '@mui/icons-material'

const useStyles = makeStyles((theme) => ({
  cardHeaderRoot: {
    cursor: 'pointer',
  },
  expandIcon: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  closeIcon: {
    transform: 'rotate(180deg)',
  },
}))

type Props = {
  children: ReactNode
  title: ReactNode
  subheader?: ReactNode
  subheaderTypographyProps?: CardHeaderProps['subheaderTypographyProps']
  id?: string
}

const ExpandableCard = ({ children, title, subheader, subheaderTypographyProps, id }: Props) => {
  const [open, setOpen] = useState(false)
  const classes = useStyles()
  return (
    <Card id={id}>
      <CardHeader
        action={
          <IconButton className={classNames(classes.expandIcon, { [classes.closeIcon]: open })} size="large">
            <ExpandMore />
          </IconButton>
        }
        classes={{ root: classes.cardHeaderRoot }}
        onClick={() => setOpen(!open)}
        subheader={subheader}
        subheaderTypographyProps={subheaderTypographyProps}
        title={title}
      />
      <Collapse in={open} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </Card>
  )
}

export default ExpandableCard
